import { Link } from "@chakra-ui/react";
import { Link as RouterLink, useParams } from "react-router-dom";

import {
  PageHeader,
  PageHeaderBackLink,
  PageHeaderTitle,
} from "src/layout/PageHeader";
import { IntercomSupportButtons } from "src/routes/ProductUnits/Intercoms/Intercom/IntercomSupportTools/IntercomSupportButtons";

export const IntercomSupportTools = () => {
  const { id: intercomId } = useParams<{ id: string }>();
  return (
    <PageHeader buttons={<IntercomSupportButtons intercomId={intercomId} />}>
      <PageHeaderBackLink>
        <Link as={RouterLink} to={"/product-units/intercoms"}>
          &#8249; Back to list
        </Link>
      </PageHeaderBackLink>
      <PageHeaderTitle>Support Tools</PageHeaderTitle>
    </PageHeader>
  );
};
